import i18n from 'i18next';

import { ReactComponent as NotRecordingIcon } from '../../../../assets/ch-not-recording-icon.svg';
import { ReactComponent as PowerLossIcon } from '../../../../assets/ch-power-loss-icon.svg';
import { ReactComponent as LowVoltageIcon } from '../../../../assets/ch-low-voltage-icon.svg';
import { ReactComponent as SdReplaceImmediatelyIcon } from '../../../../assets/ch-sd-replace-immediately-icon.svg';
import { ReactComponent as SdReplaceSoonIcon } from '../../../../assets/ch-sd-replace-soon-icon.svg';
import { ReactComponent as MisalignmentIcon } from '../../../../assets/ch-misalignment-icon.svg';

export const CAMERA_HEALTH_ISSUE_GROUPS = {
	deviceHealthStatus: 'deviceHealthStatus',
	sdWearLevel: 'sdWearLevel',
	cameraMisalignment: 'cameraMisalignment',
	cameraBlock: 'cameraBlock',
};

export const CAMERA_HEALTH_SEVERITY = {
	critical: 'critical',
	warning: 'warning',
};

export const cameraHealthIssueTypes = () => ([
	{
		key: 'not_recording',
		group: CAMERA_HEALTH_ISSUE_GROUPS.deviceHealthStatus,
		severity: CAMERA_HEALTH_SEVERITY.critical,
		icon: NotRecordingIcon,
		title: i18n.t('dashboardPage.fleetCameraHealth.issues.notRecording.title'),
		assetColumnLabel: i18n.t('dashboardPage.fleetCameraHealth.issues.notRecording.assetColumnLabel'),
		description: i18n.t('dashboardPage.fleetCameraHealth.issues.notRecording.description'),
		resolutionSteps: i18n.t('dashboardPage.fleetCameraHealth.issues.notRecording.resolutionSteps', { returnObjects: true }),
	},
	{
		key: 'power_loss',
		group: CAMERA_HEALTH_ISSUE_GROUPS.deviceHealthStatus,
		severity: CAMERA_HEALTH_SEVERITY.critical,
		icon: PowerLossIcon,
		title: i18n.t('dashboardPage.fleetCameraHealth.issues.powerLoss.title'),
		assetColumnLabel: i18n.t('dashboardPage.fleetCameraHealth.issues.powerLoss.assetColumnLabel'),
		description: i18n.t('dashboardPage.fleetCameraHealth.issues.powerLoss.description'),
		resolutionSteps: i18n.t('dashboardPage.fleetCameraHealth.issues.powerLoss.resolutionSteps', { returnObjects: true }),
	},
	{
		key: 'low_voltage',
		group: CAMERA_HEALTH_ISSUE_GROUPS.deviceHealthStatus,
		severity: CAMERA_HEALTH_SEVERITY.warning,
		icon: LowVoltageIcon,
		title: i18n.t('dashboardPage.fleetCameraHealth.issues.lowVoltage.title'),
		assetColumnLabel: i18n.t('dashboardPage.fleetCameraHealth.issues.lowVoltage.assetColumnLabel'),
		description: i18n.t('dashboardPage.fleetCameraHealth.issues.lowVoltage.description'),
		resolutionSteps: i18n.t('dashboardPage.fleetCameraHealth.issues.lowVoltage.resolutionSteps', { returnObjects: true }),
	},
	{
		key: 'sd_replace_immediately',
		group: CAMERA_HEALTH_ISSUE_GROUPS.sdWearLevel,
		severity: CAMERA_HEALTH_SEVERITY.critical,
		icon: SdReplaceImmediatelyIcon,
		title: i18n.t('dashboardPage.fleetCameraHealth.issues.sdReplaceImmediately.title'),
		assetColumnLabel: i18n.t('dashboardPage.fleetCameraHealth.issues.sdReplaceImmediately.assetColumnLabel'),
		description: i18n.t('dashboardPage.fleetCameraHealth.issues.sdReplaceImmediately.description'),
		resolutionSteps: i18n.t('dashboardPage.fleetCameraHealth.issues.sdReplaceImmediately.resolutionSteps', { returnObjects: true }),
	},
	{
		key: 'sd_replace_soon',
		group: CAMERA_HEALTH_ISSUE_GROUPS.sdWearLevel,
		severity: CAMERA_HEALTH_SEVERITY.warning,
		icon: SdReplaceSoonIcon,
		title: i18n.t('dashboardPage.fleetCameraHealth.issues.sdReplaceSoon.title'),
		assetColumnLabel: i18n.t('dashboardPage.fleetCameraHealth.issues.sdReplaceSoon.assetColumnLabel'),
		description: i18n.t('dashboardPage.fleetCameraHealth.issues.sdReplaceSoon.description'),
		resolutionSteps: i18n.t('dashboardPage.fleetCameraHealth.issues.sdReplaceSoon.resolutionSteps', { returnObjects: true }),
	},
	{
		key: 'driver_camera_misaligned',
		group: CAMERA_HEALTH_ISSUE_GROUPS.cameraMisalignment,
		severity: CAMERA_HEALTH_SEVERITY.warning,
		icon: MisalignmentIcon,
		title: i18n.t('dashboardPage.fleetCameraHealth.issues.misalignmentDriver.title'),
		assetColumnLabel: i18n.t('dashboardPage.fleetCameraHealth.issues.misalignmentDriver.assetColumnLabel'),
		description: i18n.t('dashboardPage.fleetCameraHealth.issues.misalignmentDriver.description'),
		resolutionSteps: i18n.t('dashboardPage.fleetCameraHealth.issues.misalignmentDriver.resolutionSteps', { returnObjects: true }),
	},
	{
		key: 'road_camera_misaligned',
		group: CAMERA_HEALTH_ISSUE_GROUPS.cameraMisalignment,
		severity: CAMERA_HEALTH_SEVERITY.warning,
		icon: MisalignmentIcon,
		title: i18n.t('dashboardPage.fleetCameraHealth.issues.misalignmentRoad.title'),
		assetColumnLabel: i18n.t('dashboardPage.fleetCameraHealth.issues.misalignmentRoad.assetColumnLabel'),
		description: i18n.t('dashboardPage.fleetCameraHealth.issues.misalignmentRoad.description'),
		resolutionSteps: i18n.t('dashboardPage.fleetCameraHealth.issues.misalignmentRoad.resolutionSteps', { returnObjects: true }),
	},
	{
		key: 'driver_camera_blocked',
		group: CAMERA_HEALTH_ISSUE_GROUPS.cameraBlock,
		severity: CAMERA_HEALTH_SEVERITY.critical,
		icon: NotRecordingIcon,
		title: i18n.t('dashboardPage.fleetCameraHealth.issues.cameraBlockDriver.title'),
		assetColumnLabel: i18n.t('dashboardPage.fleetCameraHealth.issues.cameraBlockDriver.assetColumnLabel'),
		description: i18n.t('dashboardPage.fleetCameraHealth.issues.cameraBlockDriver.description'),
		resolutionSteps: i18n.t('dashboardPage.fleetCameraHealth.issues.cameraBlockDriver.resolutionSteps', { returnObjects: true }),
	},
]);
